var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._b({staticClass:"p-main-navigation__link",class:{
    'p-main-navigation__link--active': _vm.isActive,
  },attrs:{"href":_vm.href}},'a',_vm.$attrs,false),[_c('span',{staticClass:"p-main-navigation__icon"},[_c('p-icon',{attrs:{"name":_vm.icon,"height":"20"}})],1),_vm._v(" "),_c('span',{staticClass:"p-main-navigation__label"},[_vm._v(_vm._s(_vm.$t(_vm.label)))])])}
var staticRenderFns = []

export { render, staticRenderFns }